import React, { Component } from 'react'

import CartNotificationsMenu from '../../components/CartNotificationsMenu'
import NotificationsMenu from '../../components/NotificationsMenu'
import { createRoot } from 'react-dom/client'

const cartMenu = document.getElementById('cart-notifications-menu-react')
if (cartMenu) {
  let root = createRoot(cartMenu)
  root.render(
    <React.StrictMode>
      <CartNotificationsMenu />
    </React.StrictMode>,
  )
}
const notificationsMenu = document.getElementById('notifications-menu-react')
if (notificationsMenu) {
  let root = createRoot(notificationsMenu)
  root.render(
    <React.StrictMode>
      <NotificationsMenu />
    </React.StrictMode>,
  )
}

class Header extends Component {
  render() {
    return <span />
  }
}

export default Header
